import { useContext } from 'react';
import { TradingHoursRestrictionContext } from '../contexts/TradingHoursRestrictionContext';

/**
 * Hook for checking trading hours restriction status (trading time windows).
 * Consumes shared TradingHoursRestrictionContext to avoid duplicate API requests.
 * Falls back to null if used outside provider (Settings page uses provider).
 */
const useTradingHoursRestriction = () => {
  const context = useContext(TradingHoursRestrictionContext);
  if (!context) {
    throw new Error('useTradingHoursRestriction must be used within TradingHoursRestrictionProvider');
  }
  return context;
};

export default useTradingHoursRestriction;
